module.exports = __webpack_public_path__ + "img/Ident-Process-9.caee0fcc.png";